import React, {
  Component, Fragment, useEffect, useState,
} from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Avatar, Dropdown, Select, Tooltip,
} from 'antd';
import TenantActions from '@Actions/tenantActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUserPlus, faSearch, faClose,
} from '@fortawesome/free-solid-svg-icons';
import './style.scss';
import H3Text from '@Uilib/h3Text';
import { LoadingOutlined } from '@ant-design/icons';
import Helpers from '@Apis/helpers';
import QualityCheckActions from '@Actions/quality/qualityCheckActions';
import PRZSelect from '../UI/PRZSelect';

const { Option } = Select;

function SelectAppUser({
  user, users, tenantId, selectedUsers, onSelect, onRemove, disabled, userList, containerClassName, labelClassName, hideTitle, title, showError, selectedUser,
  getUsers, customStyle, onChange, getOrgUsers, orgUsers, isMultiple, placeholder, allUsers, org, maxTagCount, qcData, updateQualityCheckAssignees,
}) {
  const [searchKeyword, setSearchKeyword] = useState('');

  useEffect(() => {
    if (tenantId) {
      getUsers(tenantId || user?.tenant_info?.tenant_id);
    } else if (allUsers) {
      const orgAllUsers = org?.organisation?.[0]?.tenant_ids?.map((item) => item?.tenant_id);
      getOrgUsers(orgAllUsers?.join(','), () => { });
    } else if (user) {
      getOrgUsers(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.CUSTOMER, Helpers.permissionTypes.READ)?.join(','), () => { });
    }
  }, [user, tenantId, org, allUsers]);

  const getUserList = () => {
    if (userList) return userList;
    if (tenantId) {
      return users?.data?.[0]?.tenant_user;
    }
    return orgUsers?.data;
  };

  return (
    <Fragment>
      <div className={`${containerClassName} select-app-user`}>
        {!hideTitle ? (
          <div className={labelClassName || 'orgFormLabel'}>
            {title || 'App User'}
            {showError && <span style={{ color: 'red' }}>{'  *'}</span>}
          </div>
        )
          : <Fragment />}
        <PRZSelect
          value={selectedUser}
          mode={isMultiple ? 'multiple' : ''}
          getPopupContainer={(triggerNode) => triggerNode.parentNode}
          filterOption={false}
          showSearch
          placeholder={placeholder || 'Select Manager '}
          className="app-user-dropdown"
          onChange={(value) => {
            onChange(value);
            if (qcData) {
              const payload = {
                default_assignees: value,
                ...qcData,
              };
              updateQualityCheckAssignees(payload);
            }
          }}
          onSearch={(value) => {
            setSearchKeyword(value);
          }}
          maxTagCount={maxTagCount}
          style={customStyle || (isMultiple
            ? {
              borderRadius: '2px',
              fontSize: '13px',
              width: '100%',
            } : {
              borderRadius: '2px',
              height: '28px',
              fontSize: '13px',
              width: '100%',
            })}
          allowClear
          disabled={disabled}
        >
          {getUserList()?.filter((item) => (searchKeyword ? (item?.first_name?.toUpperCase()?.includes(searchKeyword?.toUpperCase()) || item?.last_name?.toUpperCase()?.includes(searchKeyword?.toUpperCase())) : true))
            ?.map((item) => (
              <Option
                key={item?.user_id}
                value={item?.user_id}
              >
                <div className="app-user__wrapper">
                  <div className="app-user-identity">
                    <Avatar
                      style={{
                        backgroundColor: Helpers.getAvatarColors(item?.first_name?.[0])?.color1,
                      }}
                    >
                      {item?.first_name.slice(0, 2).toUpperCase()}
                    </Avatar>
                  </div>
                  <div className="app-use-name">
                    {item?.first_name}
                  </div>
                </div>
              </Option>
            ))}
        </PRZSelect>
      </div>
    </Fragment>
  );
}

const mapStateToProps = ({ UserReducers, TenantReducers, QualityCheckReducers }) => ({
  user: UserReducers.user,
  org: UserReducers.org,
  getUsersLoading: UserReducers.getUsersLoading,
  users: TenantReducers.users,
  orgUsers: TenantReducers.orgUsers,
  updateQualityCheckAssigneesLoading: QualityCheckReducers.updateQualityCheckAssigneesLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getUsers: (tenantId, roleId) => dispatch(TenantActions.getUsers(tenantId, roleId)),
  getOrgUsers: (tenantIds, callback) => dispatch(TenantActions.getOrgUsers(tenantIds, callback)),
  updateQualityCheckAssignees: (payload, callback) => dispatch(QualityCheckActions.updateQualityCheckAssignees(payload, callback)),
});

SelectAppUser.propTypes = {
  user: PropTypes.any,
  org: PropTypes.any,
  users: PropTypes.any,
  getUsers: PropTypes.func,
  disabled: PropTypes.bool,
  title: PropTypes.any,
  hideTitle: PropTypes.bool,
  tenantId: PropTypes.any,
  orgUsers: PropTypes.any,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(SelectAppUser));
